// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';

const TITLE = 'Google Podcasts';

export function GooglePodcasts() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      aria-label={TITLE}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{TITLE}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C11.6685 2 11.3505 2.13167 11.1161 2.36609C10.8817 2.60051 10.75 2.91848 10.75 3.25V4.60999C10.75 4.94151 10.8817 5.25948 11.1161 5.4939C11.3505 5.72832 11.6685 5.85999 12 5.85999C12.3315 5.85999 12.6495 5.72832 12.8839 5.4939C13.1183 5.25948 13.25 4.94151 13.25 4.60999V3.25C13.25 2.91848 13.1183 2.60051 12.8839 2.36609C12.6495 2.13167 12.3315 2 12 2Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.56982 6C7.2383 6 6.92046 6.13167 6.68604 6.36609C6.45161 6.60051 6.31982 6.91848 6.31982 7.25V11.71C6.31982 12.0415 6.45161 12.3595 6.68604 12.5939C6.92046 12.8283 7.2383 12.96 7.56982 12.96C7.90134 12.96 8.21932 12.8283 8.45374 12.5939C8.68816 12.3595 8.81982 12.0415 8.81982 11.71V7.25C8.81982 6.91848 8.68816 6.60051 8.45374 6.36609C8.21932 6.13167 7.90134 6 7.56982 6Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.25 10.0699C2.91848 10.0699 2.60051 10.2017 2.36609 10.4362C2.13167 10.6706 2 10.9884 2 11.3199V12.6801C2 13.0116 2.13167 13.3294 2.36609 13.5638C2.60051 13.7983 2.91848 13.9301 3.25 13.9301C3.58152 13.9301 3.89949 13.7983 4.13391 13.5638C4.36833 13.3294 4.5 13.0116 4.5 12.6801V11.3199C4.5 10.9884 4.36833 10.6706 4.13391 10.4362C3.89949 10.2017 3.58152 10.0699 3.25 10.0699Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 11.3199C22 10.9884 21.8683 10.6706 21.6339 10.4362C21.3995 10.2017 21.0815 10.0699 20.75 10.0699C20.4185 10.0699 20.1005 10.2017 19.8661 10.4362C19.6317 10.6706 19.5 10.9884 19.5 11.3199V12.6899C19.5 13.0215 19.6317 13.3394 19.8661 13.5739C20.1005 13.8083 20.4185 13.9399 20.75 13.9399C21.0815 13.9399 21.3995 13.8083 21.6339 13.5739C21.8683 13.3394 22 13.0215 22 12.6899V11.3199Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.68604 14.5261C6.92046 14.2917 7.2383 14.16 7.56982 14.16C7.90134 14.16 8.21932 14.2917 8.45374 14.5261C8.68816 14.7605 8.81982 15.0785 8.81982 15.41V16.77C8.81982 17.1015 8.68816 17.4195 8.45374 17.6539C8.21932 17.8884 7.90134 18.02 7.56982 18.02C7.2383 18.02 6.92046 17.8884 6.68604 17.6539C6.45161 17.4195 6.31982 17.1015 6.31982 16.77V15.41C6.31982 15.0785 6.45161 14.7605 6.68604 14.5261Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5463 6.36609C15.7807 6.13167 16.0987 6 16.4302 6C16.7617 6 17.0795 6.13167 17.314 6.36609C17.5484 6.60051 17.6802 6.91848 17.6802 7.25V8.60999C17.6802 8.94151 17.5484 9.25948 17.314 9.4939C17.0795 9.72832 16.7617 9.85999 16.4302 9.85999C16.0987 9.85999 15.7807 9.72832 15.5463 9.4939C15.3118 9.25948 15.1802 8.94151 15.1802 8.60999V7.25C15.1802 6.91848 15.3118 6.60051 15.5463 6.36609Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1161 18.5061C11.3505 18.2717 11.6685 18.14 12 18.14C12.3315 18.14 12.6495 18.2717 12.8839 18.5061C13.1183 18.7405 13.25 19.0585 13.25 19.39V20.75C13.25 21.0815 13.1183 21.3995 12.8839 21.6339C12.6495 21.8683 12.3315 22 12 22C11.6685 22 11.3505 21.8683 11.1161 21.6339C10.8817 21.3995 10.75 21.0815 10.75 20.75V19.39C10.75 19.0585 10.8817 18.7405 11.1161 18.5061Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.4302 11.09C16.0987 11.09 15.7807 11.2218 15.5463 11.4562C15.3118 11.6906 15.1802 12.0084 15.1802 12.34V16.77C15.1802 17.1015 15.3118 17.4195 15.5463 17.6539C15.7807 17.8884 16.0987 18.02 16.4302 18.02C16.7617 18.02 17.0795 17.8884 17.314 17.6539C17.5484 17.4195 17.6802 17.1015 17.6802 16.77V12.34C17.6802 12.0084 17.5484 11.6906 17.314 11.4562C17.0795 11.2218 16.7617 11.09 16.4302 11.09Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1161 7.47607C11.3505 7.24165 11.6685 7.10999 12 7.10999C12.3315 7.10999 12.6495 7.24165 12.8839 7.47607C13.1183 7.71049 13.25 8.02846 13.25 8.35999V15.64C13.25 15.9715 13.1183 16.2895 12.8839 16.5239C12.6495 16.7583 12.3315 16.89 12 16.89C11.6685 16.89 11.3505 16.7583 11.1161 16.5239C10.8817 16.2895 10.75 15.9715 10.75 15.64V8.35999C10.75 8.02846 10.8817 7.71049 11.1161 7.47607Z"
        fill="currentColor"
      />
    </svg>
  );
}
